<template lang="pug">
</template>

<style lang="stylus" scoped>
</style>


<script>
import { defineComponent, computed, ref, reactive ,onBeforeMount ,onMounted, onUpdated, onBeforeUnmount , onUnmounted , watch } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import GtagManager from '@/lib/gtagmanager.js'

export default defineComponent({
  components:{
  },

  setup(props, context) {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    onMounted(()=>{
      store.ui.state.maptype = Number(route.params.id)

      //gtag
      if(store.ui.state.init){
        GtagManager.send(
          router.currentRoute.value.fullPath,
          store.ui.state.meta.title
        )
      }
    })
    onUnmounted(()=>{
    })
    onUpdated(()=>{
      store.ui.state.maptype = Number(route.params.id)
      
      //gtag
      if(store.ui.state.init){
        GtagManager.send(
          router.currentRoute.value.fullPath,
          store.ui.state.meta.title
        )
      }
      
    })
    

    return{
    }
  }
})
</script>
